var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edu-frame",staticStyle:{"background-color":"rgb(239 239 239)"}},[_c('edu-top-header'),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","align-items":"center","margin-top":"60%"}},[_c('van-loading',{attrs:{"size":"24px"}},[_vm._v("加载中...")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }